import z from 'zod';
import { ProjectTaskShape } from './workspace-model';

export const shapes = {
    UpdateProjectCommand: z.object({
        workspaceId: z.string(),
        projectId: z.string(),
        origin: z.string(),
    }),
    AddProjectCommand: z.object({
        workspaceId: z.string(),
        name: z.string(),
        color: z.string().optional(),
        asFirst: z.boolean().optional(),
    }),
    RenameProjectCommand: z.object({
        workspaceId: z.string(),
        name: z.string(),
    }),
    SetProjectColorCommand: z.object({
        workspaceId: z.string(),
        color: z.string(),
    }),
    ArchiveProjectCommand: z.object({
        workspaceId: z.string(),
        projectId: z.string(),
    }),
    UnarchiveProjectCommand: z.object({
        workspaceId: z.string(),
        projectId: z.string(),
    }),
    DeleteProjectCommand: z.object({
        workspaceId: z.string(),
        projectId: z.string(),
    }),
    LeaveProjectCommand: z.object({
        workspaceId: z.string(),
    }),

    AddProjectResponse: z.object({
        workspaceId: z.string(),
        projectId: z.string(),
        name: z.string(),
        color: z.string().or(z.null()),
    }),
    ReadProjectTasksResponse: z.array(ProjectTaskShape),
    ReadArchivedProjectsResponse: z.array(
        z.object({
            id: z.string(),
            name: z.string(),
            color: z.string(),
        })
    ),
};

export type AddProjectCommand = z.infer<typeof shapes.AddProjectCommand>;
export type UpdateProjectCommand = z.infer<typeof shapes.UpdateProjectCommand>;
export type RenameProjectCommand = z.infer<typeof shapes.RenameProjectCommand>;
export type SetProjectColorCommand = z.infer<
    typeof shapes.SetProjectColorCommand
>;
export type ArchiveProjectCommand = z.infer<
    typeof shapes.ArchiveProjectCommand
>;
export type UnarchiveProjectCommand = z.infer<
    typeof shapes.UnarchiveProjectCommand
>;
export type DeleteProjectCommand = z.infer<typeof shapes.DeleteProjectCommand>;
export type LeaveProjectCommand = z.infer<typeof shapes.LeaveProjectCommand>;

export type AddProjectResponse = z.infer<typeof shapes.AddProjectResponse>;
export type ReadProjectTasksResponse = z.infer<
    typeof shapes.ReadProjectTasksResponse
>;
export type ReadArchivedProjectsResponse = z.infer<
    typeof shapes.ReadArchivedProjectsResponse
>;
